export const APP_ID = "ed813c1c429a45bda74ec28fb2fccc78";
export const MAX_CAPACITY = 2;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;
